<template>
  <div class="ksm-modus__untersuchung-wrapper">
    <split-layout :cols="2">
      <!-- split-layout main -->
      <div slot="main-content" class="ksm-texte__modus-main">
        <!-- toolbar -->
        <slot name="modusindex-toolbar"></slot>
        <div class="ksm-modus__untersuchung-main-wrapper">
          <!-- untersuchung main content -->
          <div class="ksm-modus__untersuchung-main">
            <!-- deepzoom -->
            <div class="ksm-flex-1">
              <deepzoom-view
                @changePage="changeSeite"
                :modusOption="modusOption"
                :seiteIdx="seiteIdx"
                :seiten="seiten"
                key="keep_untersuchung_1"
              ></deepzoom-view>
            </div>
          </div>
          <!-- untersuchung main content end -->
        </div>

        <!-- thumbnail start -->
        <div class="ksm-untersuchung-footer">
          <foot-thumbnail
            @selectItem="changeSeite"
            :seiten="seiten"
            :seiteIdx="seiteIdx"
            :aligen="'horizontal'"
          ></foot-thumbnail>
        </div>
        <!-- thumbnail end -->
      </div>
      <!-- split-layout main end -->
      <!-- spit-layout sidebar -->
      <div slot="sidebar-2" class="ksm-flex-1" style="position:relative">
        <sidebar-view :merz="merz" :modusOption="modusOption" :seiteIdx="seiteIdx"></sidebar-view>
      </div>
    </split-layout>
  </div>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import SplitLayout from "comps/SplitLayout.vue";
import DeepzoomView from "comps/DeepzoomView.vue";
import Thumbnail from "comps/Thumbnail.vue";

import MixinsModus from "comps/mixins/Modus.vue";

export default {
  props: ["viewKey"],
  mixins: [MixinsModus],
  components: {
    "deepzoom-view": DeepzoomView,
    "split-layout": SplitLayout,
    "sidebar-view": Sidebar,
    "foot-thumbnail": Thumbnail
  },
  data() {
    return {
      modusId: "untersuchungsmodus"
    };
  }
};
</script>

<style lang="scss"
 scoped>
$footerHeight: 150px;
.ksm-modus__untersuchung-wrapper {
  @extend .ksm-flex;
  @extend .ksm-content-font;
  justify-content: center;
}
.ksm-modus__untersuchung-main-wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-texte__modus-body;
  position: relative;
}
.ksm-modus__untersuchung-main {
  @extend .ksm-flex;
  @extend .ksm-position-absolute;
}
.ksm-untersuchung-footer {
  @extend .ksm-flex-00auto;
  height: $footerHeight;
  @extend .ksm-flex;
  margin: 0px 20px;
}
</style>


// WEBPACK FOOTER //
// Untersuchung.vue?0b820148